"use client";

import { PQS_TIER_RANGES } from "@repo/core/client";
import { Badge } from "@ui/components/badge";
import { cn } from "@ui/lib";
import { tierBadgeStatus } from "../lib/tier-status";

/**
 * An AIPVS tier pill: "Premium", "Strong", "Moderate" or "Limited" on the
 * tier's Badge status. The label comes from the score's own `tierLabel` when
 * the caller has it, else from the shared tier ranges, so every surface names
 * a tier the same way.
 */
export function AipvsTierBadge({
	tier,
	tierLabel,
	className,
}: {
	tier: number;
	tierLabel?: string | null;
	className?: string;
}) {
	const label =
		tierLabel ??
		PQS_TIER_RANGES.find((range) => range.tier === tier)?.label ??
		String(tier);
	return (
		<Badge
			status={tierBadgeStatus(tier)}
			className={cn(
				"whitespace-nowrap px-2 py-0.5 normal-case",
				className,
			)}
		>
			{label}
		</Badge>
	);
}
